import { SVGProps } from 'react';

export function CatCryingFace(props: SVGProps<SVGSVGElement>) {
  return (
    <svg id="emoji" viewBox="0 0 72 72" xmlns="http://www.w3.org/2000/svg" data-testid="cat-crying-face" {...props}>
      <g id="color">
        <path
          fill="#F4AA41"
          d="M58.6655,48.8322c-3.5976,9.1169-12.6313,15.1546-23.2072,15.1546c-9.1173,0-19.256-5.8476-22.8536-14.9645 l-0.1262-0.3127c-1.1415-2.8597-0.9573-6.3599-0.9573-9.6324L15.1881,6.706l10.2281,10.0799 c2.9226-1.2477,6.137-1.9388,9.5103-1.9388H35.99c3.3733,0,6.5877,0.6911,9.5103,1.9388L56.7285,5.706l3.7223,33.8758 c0,3.2725-0.6283,6.3969-1.7707,9.2566"
        />
        <path
          fill="#E27022"
          d="M35.4583,63.9868c10.6088,0.3425,20.3541-6.004,23.9517-15.1208l0.1109-0.231 c1.1415-2.8597,0.9579-6.8965,0.9579-10.169l-3.7503-32.76"
        />
        <path
          fill="#FFFFFF"
          d="M55.1059,33.527c0,0-9.2757-9.2767-13.2519,6.6249C52.4561,48.1032,55.1059,33.527,55.1059,33.527z"
        />
        <path
          fill="#FFFFFF"
          d="M16.8941,33.527c0,0,9.2757-9.2767,13.2519,6.6249C19.5439,48.1032,16.8941,33.527,16.8941,33.527z"
        />
        <path
          fill="#92D3F5"
          d="M20.92,48.1939c-1.1993,1.4205-3.4442,4.4727-3.4442,7.4143c-0.0014,0.9206,0.3576,1.7853,1.0068,2.4345 c0.6507,0.6507,1.5153,1.0097,2.4375,1.0098c1.8413-0.0001,3.4457-1.6044,3.4443-3.4443l0,0 C24.3643,52.6666,22.1193,49.6145,20.92,48.1939z"
        />
      </g>
      <g id="hair" />
      <g id="skin" />
      <g id="skin-shadow" />
      <g id="line">
        <path
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="2"
          d="M55.1059,33.4851c0,0-9.2757-9.2767-13.2519,6.6249C52.4561,48.0613,55.1059,33.4851,55.1059,33.4851z"
        />
        <line
          x1="62"
          x2="52.64"
          y1="53.9235"
          y2="48.7235"
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="2"
        />
        <line
          x1="57.84"
          x2="48.48"
          y1="59.1235"
          y2="53.9235"
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="2"
        />
        <path
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="2"
          d="M13.2916,47.7952c-1.1172-2.7655-1.7316-5.787-1.7316-8.9517l3.64-32.76l10.9799,10.7149c2.858-1.2066,6.0013-1.8749,9.3001-1.8749 h1.04c3.2988,0,6.4421,0.6683,9.3001,1.8749L56.8,6.0835l3.64,32.76c0,3.1647-0.6144,6.1862-1.7316,8.9517"
        />
        <path
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="2"
          d="M27.004,61.4549C29.6388,62.4535,32.4956,63,35.4802,63h1.04c4.6465,0,8.9852-1.3243,12.6547-3.6176"
        />
        <path
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="2"
          d="M16.8941,33.4851c0,0,9.2757-9.2767,13.2519,6.6249C19.5439,48.0613,16.8941,33.4851,16.8941,33.4851z"
        />
        <line
          x1="10"
          x2="18.7195"
          y1="53.9235"
          y2="49.0793"
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="2"
        />
        <line
          x1="16.01"
          x2="14.16"
          y1="58.0909"
          y2="59.1209"
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="2"
        />
        <circle cx="23.52" cy="36.2435" r="2.08" />
        <circle cx="48.48" cy="36.2435" r="2.08" />
        <path d="M24.8268,59.473c-1.0428,1.0428-2.4302,1.6172-3.9068,1.6173c-1.4765,0-2.864-0.5746-3.9082-1.6187 c-1.0428-1.0428-1.6173-2.4302-1.6159-3.9053c0-4.8605,4.5933-9.5084,4.7887-9.7038c0.4065-0.4064,1.0643-0.4064,1.4708,0 c0.1953,0.1953,4.7887,4.8432,4.7886,9.7037l0,0C26.4455,57.0413,25.871,58.4289,24.8268,59.473z M20.92,48.152 c-1.1993,1.4205-3.4442,4.4727-3.4442,7.4143c-0.0014,0.9206,0.3576,1.7853,1.0068,2.4345 c0.6507,0.6507,1.5153,1.0097,2.4375,1.0098c1.8413-0.0001,3.4457-1.6044,3.4443-3.4443l0,0 C24.3643,52.6247,22.1193,49.5726,20.92,48.152z" />
        <line
          x1="40.16"
          x2="36"
          y1="52.08"
          y2="46.88"
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="2"
        />
        <line
          x1="31.84"
          x2="36"
          y1="52.08"
          y2="46.88"
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="2"
        />
        <line
          x1="31.84"
          x2="40.16"
          y1="46.88"
          y2="46.88"
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="2"
        />
      </g>
    </svg>
  );
}
